// src/components/ArtisanComponent.js

import React from 'react';
import { Link } from 'react-router-dom';
import './ArtisanComponent.css'; // Import CSS for styling

const ArtisanComponent = () => {
  return (
    <section className="artisan-wrapper">
      <div className="artisan-container">
        <div className="artisan-content">
          <p className="artisan-tag">Delicious</p>
          <h1 className="artisan-title">Curated Culinary Creations</h1>
          <p className="artisan-description">
            Welcome to a realm of meticulously crafted culinary masterpieces, where every dish is a testament to artistry and flavour.
          </p>
        </div>
        <div className="artisan-action">
          <Link to="/all-foods">
            <button className="choice-view-more-btn">
              View Full Menu
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ArtisanComponent;
